export const explore_menu_data= [
    {
      label: "About Us",
      url: "/explore-telecel/",
      children: [
      ],
    },
    {
      label: "Executive Team",
      url: "/explore-telecel/executive-team/",
      children: [
      ],
    },
    {
      label: "Careers",
      url: "/explore-telecel/careers/",
      children: [
        {
          label: "Career Opportunities",
          icon: "top-up-system",
          url: "#",
          children: [
        {
          label: "Graduate program",
          url: "/explore-telecel/careers/nextgen/",
          children: [],
        },
        {
          label: "Code Like a Girl",
          url: "/explore-telecel/careers/code-like-a-girl/",
          children: [],
        },
        {
          label: "Female ENG. Student Sponsorship Program",
          url: "/explore-telecel/careers/fessp/",
          children: [],
        },
        {
          label: "Reconnect",
          url: "/explore-telecel/careers/reconnect/",
          children: [],
        },
        {
          label: "Internships & National Service",
          url: "/explore-telecel/careers/national-service/",
          children: [],
        },
      ],
    },
  ],
},
    // {
    //   label: "Corporate Social Responsibility",
    //   url: "#",
    //   children: [
    //   ],
    // },
  ]